import { createContext } from 'react';
export const EntityEditorStateContext = createContext({
    defaultContextValue: true,
});
EntityEditorStateContext.displayName = 'EntityEditorStateContext';
//# sourceMappingURL=EntityEditorStateContext.js.map